import React from 'react';
import { LoadingHeader as LoadingHeaderComponent, LoadingHeaderOld as LoadingHeaderOldComponent } from '@pushpay/shell';
import Skeleton, { SkeletonAvatar } from '@pushpay/skeleton';
import { createUseStyles } from '@pushpay/styles';
import { useMediaBreakpoint } from '@pushpay/theming';
import { Divider } from './divider';
const useStyles = createUseStyles(theme => ({
  skeletonAvatar: {
    marginRight: theme.SPACING.MEDIUM
  },
  skeletonOrgSwitcher: {
    width: '136px',
    marginRight: theme.SPACING.SMALL
  },
  divider: {
    marginLeft: theme.SPACING.SMALL,
    marginRight: theme.SPACING.SMALL
  }
}));

const LoadingHeader = props => {
  const {
    classes: classesProp,
    className: classNameProp,
    'data-pp-at-target': targetId,
    deprecated,
    ...rest
  } = props;
  const isTabletAndBelow = useMediaBreakpoint('TABLET_AND_BELOW');
  const classes = useStyles(classesProp);

  if (deprecated) {
    return /*#__PURE__*/React.createElement(LoadingHeaderOldComponent, Object.assign({
      toolBar: /*#__PURE__*/React.createElement(React.Fragment, null, !isTabletAndBelow && /*#__PURE__*/React.createElement(SkeletonAvatar, {
        size: 24,
        className: classes.skeletonAvatar,
        "data-pp-at-target": `${targetId}-toolbar-icon1`
      }), /*#__PURE__*/React.createElement(SkeletonAvatar, {
        size: 24,
        "data-pp-at-target": `${targetId}-toolbar-icon2`
      }), !isTabletAndBelow && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
        classes: {
          root: classes.divider
        }
      }), /*#__PURE__*/React.createElement(Skeleton, {
        className: classes.skeletonOrgSwitcher,
        rows: [{
          width: 100
        }],
        "data-pp-at-target": `${targetId}-org-switcher`
      }))),
      "data-pp-at-target": "cap-layout-loading-header"
    }, rest));
  }

  return /*#__PURE__*/React.createElement(LoadingHeaderComponent, Object.assign({
    toolBar: /*#__PURE__*/React.createElement(React.Fragment, null, !isTabletAndBelow && /*#__PURE__*/React.createElement(SkeletonAvatar, {
      size: 24,
      className: classes.skeletonAvatar,
      "data-pp-at-target": `${targetId}-toolbar-icon1`
    }), /*#__PURE__*/React.createElement(SkeletonAvatar, {
      size: 24,
      "data-pp-at-target": `${targetId}-toolbar-icon2`
    })),
    "data-pp-at-target": "cap-layout-loading-header"
  }, rest));
};

export default LoadingHeader;